import { Customer } from "@/modules/customers/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/customers"

export const fetchCustomers = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchCustomer = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createCustomer = async (data?: Customer) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updateCustomer = async (id: string, data?: Customer) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deleteCustomer = async (data: Customer) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updateCustomer(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
